import {Component, Input} from '@angular/core';
import {FieldsConfigCommon} from './fields-config-common';
import {FieldBranchInformation} from './config/branch-information';
import {FieldBranches} from './config/branches';
import {FieldCalculatedFields} from './config/calculated-fields';
import {FieldCheckbox} from './config/checkbox';
import {FieldDate} from './config/date';
import {FieldDropdown} from './config/dropdown';
import {FieldDuplicateBlock} from './config/duplicate-block';
import {FieldEmployees} from './config/employees';
import {FieldFile} from './config/file';
import {FieldMultipleSelection} from './config/multiple-selection';
import {FieldNote} from './config/note';
import {FieldRadio} from './config/radio';
import {FieldRichText} from './config/rich-text';
import {FieldScale} from './config/scale';
import {FieldSelectedEmployeeInformation} from './config/selected-employee-information';
import {FieldSignature} from './config/signature';
import {FieldTextfield} from './config/textfield';
import {FieldUserInformation} from './config/user-information';

@Component({
  selector: 'ng-fields-config-switch',
  templateUrl: './fields-config-switch.html',
  imports: [
    FieldsConfigCommon,
    FieldBranchInformation,
    FieldBranches,
    FieldCalculatedFields,
    FieldCheckbox,
    FieldDate,
    FieldDropdown,
    FieldDuplicateBlock,
    FieldEmployees,
    FieldFile,
    FieldMultipleSelection,
    FieldNote,
    FieldRadio,
    FieldRichText,
    FieldScale,
    FieldSelectedEmployeeInformation,
    FieldSignature,
    FieldTextfield,
    FieldUserInformation
  ]
})
export class FieldsConfigSwitch {
  @Input() field: any;
}
